module.exports = __webpack_public_path__ + "static/media/lupa-search.3c0a3aa0.png";